module.exports = __webpack_public_path__ + "img/GH-kyujin-top-back005sp-2.26f22879.webp";